import { Component } from "@angular/core";

@Component({
  selector: "app-visit-planner-static",
  standalone: false,
  template: `<app-visit-planner></app-visit-planner>`,
  styles: [
    `
      :host {
        display: block;
        height: calc(100vh - 120px);
        height: calc(100dvh - 120px);
        overflow: hidden;
      }

      :host ::ng-deep .visit-planner {
        height: 100%;
        margin: 12px 16px;
      }
    `,
  ],
})
export class VisitPlannerStaticComponent {}
